import { UserDetails, UserDetailsPayload } from 'contracts/models/admin-reports';

export const Endpoint = () => `/api/v3/admin/userdetails/`;
export const QueryKeyBase = () => ['v3', 'admin', 'reports', 'user-details'] as const;
export const QueryKey = (payload: UserDetailsPayload) => [...QueryKeyBase(), payload] as const;

export interface Response {
    userList: UserDetails[];
    totalCount: number;
}
